module.exports = require("@pb/kit-util-in-million");